export default "__VITE_ASSET__BTICgoA2__"